var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.products.length)?_c('ul',{staticClass:"products seasidetms_products col-md-12",class:_vm.columnsCount},_vm._l((_vm.products),function(product,index){return _c('product-tile',{key:product.slug,attrs:{"product":product,"index":index}})}),1):_c('div',{staticClass:"emptylist"},[_c('span',[_vm._v(_vm._s(_vm.$t('emptyCategory')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }